import { baseSplitApi } from "./index";

export const apiCredentialsApi = baseSplitApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getGatewayCredentials: builder.mutation<
      {
        api_token: string;
      },
      { point: number; otp: string }
    >({
      query: (data) => ({
        url: "/api-credentials/get-gateway-credentials/",
        method: "POST",
        body: data,
      }),
    }),
    getInvoicingCredentials: builder.mutation<
      {
        client_id: string;
        username: string;
        password: string;
      },
      void
    >({
      query: () => ({
        url: "/api-credentials/get-invoicing-credentials/",
        method: "POST",
      }),
    }),
    postUpdateGatewayCredentials: builder.mutation<
      void,
      {
        otp: string;
        point: number;
      }
    >({
      query: (body) => ({
        url: "/api-credentials/update-gateway-credentials/",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetGatewayCredentialsMutation,
  useGetInvoicingCredentialsMutation,
  usePostUpdateGatewayCredentialsMutation,
} = apiCredentialsApi;
